import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ItemMetadataModule } from '®app/shared/item-metadata';
import { FieldedItemModule, OnlineResourcesModule } from '®shared/list-item';
import { AvailabilityModule } from '®shared/resource-availability';

import { ResourceDetailsComponent } from './resource-details.component';
import { ResourceComponent } from './resource.component';

@NgModule({
  imports: [
    CommonModule,
    FieldedItemModule,
    AvailabilityModule,
    ItemMetadataModule,
    OnlineResourcesModule,
  ],
  declarations: [ResourceComponent, ResourceDetailsComponent],
  exports: [ResourceComponent, ResourceDetailsComponent],
})
export class SharedResourceModule {}
